import { Component, OnInit, Inject } from '@angular/core';
import { CustomerNote } from '../../../shared/models/customer.note.interface';
import { SummaryComponent } from '../summary.component';
import { MessageNnotificationTypes_Enum } from '../../../admin/enums/message-notification-types.enum';
import { Contact } from '../../../shared/models/contact.interface';
import { ContactType } from '../../../shared/models/contact.type.interface';


export interface ContactDialogData {
  contact: Contact;
  contactTypes: ContactType[];
  notificationTypes: MessageNnotificationTypes_Enum;
}
export interface NoteDialogData {
  note: CustomerNote;
}
export interface DocumentDialogData {
  document: CustomerNote;

  noteFile: any;
  messages: string[];
}

@Component({
  selector: 'app-summary-desktop',
  templateUrl: './summary-desktop.component.html',
  styleUrls: ['./summary-desktop.component.scss']
})
export class SummaryDesktopComponent extends SummaryComponent implements OnInit {
  ngOnInit() {
    super.init();
  }

}


